define 'controller/ShowMoreProductsController', ['jquery', 'lib/kryptonite'], ($) ->
  class ShowMoreProductsController

    constructor: (@$el) ->
      self = @
      $('[data-controller-element=article-tile][data-first-loaded]').focus()
      @$el.on 'click', (e) =>
        e.preventDefault()
        $button = @$el
        if $('.category').length > 0 && $button.data('url').length > 0
          url = $button.data('url')
          $button.attr('disabled', true)
          $button.find('[data-controller-element=btn-text]').html("Chargement en cours")

          $('[data-controller-element=article-tile][data-first-loaded]').removeAttr('data-first-loaded')

          if history.pushState?
            history.pushState(null, null, url)
          $.kryptonite
            url: url + '&more=1&ajax=true'
            method: 'GET'
            success: ->
              $('#productList').trigger('plp:insert-marketing', true)
              $('#productList').trigger('plp:new-products-loaded', true)

    destroy: ->
      @$el.off()